import { AppContext } from '../state/index.mjs';
import {useContext} from 'react';

/**
 * @typedef GuideConfigurationsHookValues
 * @property {number} guideId - returns the guide ID for the conversation
 * @property {string} guideType - returns "consumer", "business", or "hybrid" based on guideType
 * @property {boolean} isBranchGuide - true if conversation is a branch guide
 * @property {boolean} isMockMode - true if mock service is being used
 * @property {boolean} isRemoteSession - true is this conversation is a remote session
 * @property {string} runMode - environment run mode
 *
 * @return {GuideConfigurationsHookValues}
 */
const useGuideConfig = () => {
  const appContextState = useContext(AppContext);
  const guideConfigsObj = appContextState.guideConfigurations;
  const { guideId, guideType, isRemoteSession } = appContextState.user;
  return {
    ...guideConfigsObj,
    guideId,
    guideType,
    isRemoteSession
  };
};

export { useGuideConfig };
